import $ from 'jquery'
import appDisplay from 'scoreboard/components/app-display'
import errorHandler from 'scoreboard/components/error-handler'

/**
 * Shared code to launch a dialog used to edit an import
 * @param {Object} options
 * @param {Integer} [options.importId] the ID of the import
 * @param {Boolean} [options.examples = true] if false, retrieve all records
 * @param {Boolean} [options.statuses = false] if true, retrieve connection status
 * @param viewCreator a callback which creates a view to be displayed in the
 * dialog. The function is invoked with the response from the import-data
 * endpoint.
 */
function viDialog(options, viewCreator) {
	let params = $.param(options)
	let url = `api/imports/import-data?${params}`
	// #32519 provide error handler with showEmptyState: false
	// so we don't get a blank grey background for the  imports screen when
	// there is a problem with retrieving the import data
	let promise = $.ajax({
		url,
		error: xhr => errorHandler(xhr, {showEmptyState: false})
	})
	appDisplay.dialog(promise, viewCreator)
}

export default viDialog

viDialog.__filename__ = 'imports/vi/vi-dialog.js'
